import dialtoneChangelog from '@workspaceRoot/CHANGELOG.json';

export const DIALTONE_CHANGELOGS = {
  Dialtone: {
    json_file: dialtoneChangelog,
    url_handler: 'dialtone',
  },
};

export default {
  DIALTONE_CHANGELOGS,
};
